import React from 'react';

const FourMethods: React.FC = () => {
  const methods = [
    {
      number: '01',
      title: '共有者全員で売却する',
      icon: 'ri-group-2-line',
      color: 'bg-blue-50 border-blue-200',
      iconColor: 'text-blue-600',
      merit: '最も高く売れる',
      demerit: '全員の同意が必要',
      suitable: '共有者間で話し合いができる場合',
      description: '共有者全員が売却に同意すれば、通常の不動産売却と同じように市場価格で売却できます。最も高値で売却できる方法ですが、全員の同意を得るのが難しいケースが多いです。'
    },
    {
      number: '02',
      title: '自分の持分だけを売却する',
      icon: 'ri-pie-chart-line',
      color: 'bg-green-50 border-green-200',
      iconColor: 'text-green-600',
      merit: '他の共有者の同意が不要',
      demerit: '買い手が限られ、価格も大幅に下がる',
      suitable: '早く手放したい、他の共有者と関わりたくない場合',
      description: '自分の持分だけであれば、他の共有者の同意なく売却できます。ただし、共有持分のみを購入する買い手は限られており、市場価格の1～3割程度になることが一般的です。'
    },
    {
      number: '03',
      title: '他の共有者に持分を買い取ってもらう',
      icon: 'ri-hand-coin-line',
      color: 'bg-amber-50 border-amber-200',
      iconColor: 'text-amber-600',
      merit: '円満に解決できる',
      demerit: '相手に資金力が必要',
      suitable: '共有者の中に不動産を活用したい人がいる場合',
      description: '他の共有者が不動産を活用したいと考えている場合、持分を買い取ってもらうことで円満に解決できます。価格交渉が必要ですが、外部に売却するより高値で売れる可能性があります。'
    },
    {
      number: '04',
      title: '共有物分割請求を行う',
      icon: 'ri-scales-3-line',
      color: 'bg-purple-50 border-purple-200',
      iconColor: 'text-purple-600',
      merit: '確実に共有状態を解消できる',
      demerit: '時間と費用がかかる',
      suitable: '話し合いがまとまらない場合の最終手段',
      description: '裁判所を通じて共有状態の解消を求める手続きです。現物分割、代償分割、競売による換価分割のいずれかの方法で分割されます。時間と費用はかかりますが、確実に共有状態を解消できます。'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            共有不動産を処分する4つの方法
          </h2>
          <p className="text-xl text-gray-600">
            状況に応じた最適な解決策をご提案します
          </p>
        </div>

        <div className="max-w-6xl mx-auto space-y-6">
          {methods.map((method, index) => (
            <div
              key={index}
              className={`rounded-2xl border-2 ${method.color} overflow-hidden hover:shadow-xl transition-all duration-200`}
            >
              <div className="p-8">
                <div className="flex items-start mb-6">
                  <div className="flex-shrink-0 mr-6">
                    <div className={`w-20 h-20 ${method.iconColor} bg-white rounded-xl flex items-center justify-center border-2 ${method.color.replace('bg-', 'border-')}`}>
                      <i className={`${method.icon} text-3xl`}></i>
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center mb-3">
                      <span className={`text-5xl font-bold ${method.iconColor} opacity-20 mr-4`}>
                        {method.number}
                      </span>
                      <h3 className="text-2xl font-bold text-gray-900">
                        {method.title}
                      </h3>
                    </div>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      {method.description}
                    </p>
                  </div>
                </div>

                <div className="grid md:grid-cols-3 gap-4">
                  <div className="bg-white rounded-lg p-4 border border-gray-200">
                    <div className="flex items-center mb-2">
                      <i className="ri-check-line text-green-600 text-xl mr-2"></i>
                      <span className="font-bold text-gray-900">メリット</span>
                    </div>
                    <p className="text-gray-700">{method.merit}</p>
                  </div>

                  <div className="bg-white rounded-lg p-4 border border-gray-200">
                    <div className="flex items-center mb-2">
                      <i className="ri-close-line text-red-600 text-xl mr-2"></i>
                      <span className="font-bold text-gray-900">デメリット</span>
                    </div>
                    <p className="text-gray-700">{method.demerit}</p>
                  </div>

                  <div className="bg-white rounded-lg p-4 border border-gray-200">
                    <div className="flex items-center mb-2">
                      <i className="ri-lightbulb-line text-amber-600 text-xl mr-2"></i>
                      <span className="font-bold text-gray-900">向いている場合</span>
                    </div>
                    <p className="text-gray-700">{method.suitable}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12 p-8 bg-white rounded-2xl max-w-4xl mx-auto border-2 border-orange-200">
          <p className="text-xl font-bold text-gray-900 mb-3">
            どの方法が最適かは、状況により異なります
          </p>
          <p className="text-gray-700 leading-relaxed mb-6">
            共有者の人数、関係性、不動産の価値、緊急性などを総合的に判断し、<br />
            最適な解決策をご提案いたします。
          </p>
          <a
            href="#cta"
            className="inline-flex items-center justify-center px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-bold rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-chat-3-line text-xl mr-2"></i>
            無料相談で最適な方法を相談する
          </a>
        </div>
      </div>
    </section>
  );
};

export default FourMethods;
